import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FloatingButtonComponent} from "./component";

@NgModule({
    declarations: [
        FloatingButtonComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        FloatingButtonComponent
    ]
})

export class FloatingButtonModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/floating-button/module.ts